import {
  APP_SETTING_LOAD_LOCALIZATION_DATA_BEGIN,
  APP_SETTING_LOAD_LOCALIZATION_DATA_SUCCESS,
  APP_SETTING_LOAD_LOCALIZATION_DATA_FAILURE,
  APP_SETTING_LOAD_LOCALIZATION_DATA_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadLocalizationData(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_LOCALIZATION_DATA_BEGIN,
    });
    const { projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(`${process.env.REACT_APP_BUILDER_ENGINE}localization`, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_LOAD_LOCALIZATION_DATA_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_LOCALIZATION_DATA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadLocalizationDataError() {
  return {
    type: APP_SETTING_LOAD_LOCALIZATION_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_LOCALIZATION_DATA_BEGIN:
      return {
        ...state,
        loadLocalizationDataPending: true,
        loadLocalizationDataError: null,
      };

    case APP_SETTING_LOAD_LOCALIZATION_DATA_SUCCESS:
      return {
        ...state,
        loadLocalizationDataPending: false,
        loadLocalizationDataError: null,
        localization: action.data,
      };

    case APP_SETTING_LOAD_LOCALIZATION_DATA_FAILURE:
      return {
        ...state,
        loadLocalizationDataPending: false,
        loadLocalizationDataError: action.data.error,
      };

    case APP_SETTING_LOAD_LOCALIZATION_DATA_DISMISS_ERROR:
      return {
        ...state,
        loadLocalizationDataError: null,
      };

    default:
      return state;
  }
}
